<div
  class="flex gap-4 flex-wrap"
  *transloco="let t; scope: 'featureSearch'"
  data-id="interactive-applied-filters"
>
  @for (filter of filters(); track filter.id) {
    <bd-interactive-filter-chip
      [filter]="filter"
      [attributeCategoryDefinitions]="attributeCategoryDefinitions()"
      [editContext]="editContext()"
      [removable]="!disabled()"
      [disabled]="disabled()"
      (updateFilter)="updateFilter.emit($event)"
      (remove)="removeFilter.emit($event)"
      (searchObjects)="searchObjects.emit($event)"
      (searchUsers)="searchUsers.emit($event)"
    />
  }
  @if (filters().length > 0 && !disabled()) {
    <p-button
      data-id="clear-all-tag"
      label="{{ t('featureSearch.clearAll') }}"
      styleClass="bd-filter-tag bd-clear-filter-tag"
      [outlined]="false"
      (onClick)="removeAllFilters()"
    >
    </p-button>
  }
</div>
